export default __webpack_public_path__ + "static/media/bank-details.7a41dce4.svg";